import React from 'react';
import {OverlayTrigger, Tooltip} from 'react-bootstrap';
import * as R from 'ramda';

import {numberWithCommas, toFixedPrecision} from 'js/common/string_helper';

const BudgetDetails = ({campaign, warnSaasCampaign = false}) => {
    const {
        budget,
        objective_name,
        estimated_results,
        recommended_bid,
        internal_creator_budget,
        internal_media_budget,
        campaign_content_count,
        is_saas
    } = campaign;

    const shouldDisplaySaasWarning = warnSaasCampaign && is_saas;
    const saasWarning = (
        <OverlayTrigger
            placement="top"
            overlay={
                <Tooltip id="tooltip">
                    {`SAAS Campaigns have default rev share set to 1
                        and will use objective bid to calculate payouts on CPCC campaigns
                        You can edit this in the campaign config`}
                </Tooltip>
            }
            rootClose
        >
            <span className="label label-danger">SAAS CAMPAIGN</span>
        </OverlayTrigger>
    );

    const noValue = 'N/A';
    const getDisplayValue = value => value === null || value === 0 ? noValue : value;

    const displayEstimatedResults = getDisplayValue(estimated_results);
    const displayInternalCreatorBudget = getDisplayValue(internal_creator_budget);
    const recommendedBid = getDisplayValue(recommended_bid);
    const displayInternalMediaBudget = getDisplayValue(internal_media_budget);
    const displayCampaignContentCount = getDisplayValue(campaign_content_count);

    return (
        <>
            <div className="content-section-title">
                {shouldDisplaySaasWarning ? saasWarning : null}
            </div>

            <div className="content-section">
                <p className="content-section-title -no-margin">Budget</p>
                <span className="content-section-value">{`$${numberWithCommas(budget)}`}</span>
            </div>

            <div className="content-section">
                <p className="content-section-title -no-margin">Objective</p>
                <span className="content-section-value">{objective_name}</span>
            </div>

            <div className="content-section">
                <p className="content-section-title -no-margin">Estimated Results</p>
                <span className="content-section-value">
                    {
                        typeof displayEstimatedResults === 'number'
                            ? numberWithCommas(displayEstimatedResults)
                            : noValue
                    }
                </span>
            </div>

            <span className="content-separator"></span>

            <div className="content-section">
                <p className="content-section-title -no-margin">Content Count</p>
                <span className="content-section-value">{displayCampaignContentCount}</span>
            </div>

            <span className="content-separator"></span>

            <div className="content-section">
                <p className="content-section-title -no-margin">Recommended Bid</p>
                <span className="content-section-value">{
                    recommendedBid !== noValue ? `$${numberWithCommas(recommendedBid)}` : noValue
                }</span>
            </div>

            <div className="content-section">
                <p className="content-section-title -no-margin">Internal Creator Budget</p>
                <span className="content-section-value">{`$${displayInternalCreatorBudget}`}</span>
            </div>

            <div className="content-section">
                <p className="content-section-title -no-margin">Internal Media Budget</p>
                <span className="content-section-value">{`$${displayInternalMediaBudget}`}</span>
            </div>
        </>
    );
};

BudgetDetails.propTypes = {};

export default BudgetDetails;



// WEBPACK FOOTER //
// ./components/verify_receipt_common/budget_details.js